<ng-container *ngIf="vm$ | async as vm">
  <form
    *ngIf="!!accomplishmentGlobalAddForm"
    class="reactive-forms"
    [class.input-success-kickstart]="vm.shouldShowResults$ | async"
    [formGroup]="accomplishmentGlobalAddForm"
    (ngSubmit)="onSubmit()"
  >
    <dgx-modal
      [useDefaultForm]="false"
      [submitButtonText]="heading"
      [useDefaultSubmitButton]="false"
      [canCancel]="!(vm.shouldShowResults$ | async)"
      [modalHeaderTitle]="heading"
      [isSubmitPending]="vm.shouldSpinSubmitButton$ | async"
      [bodyClasses]="{
        'guts-p-full-2': true,
        'input-success-kickstart': (vm.shouldShowResults$ | async),
        first: true,
        second: true,
        third: false
      }"
      (dismiss)="onDismiss($event)"
    >
      <!-- Modal body -->
      <ng-container class="modal-body">
        <div class="input-success-wrap">
          <!-- Title -->
          <div class="reactive-forms__control">
            <dgx-reactive-forms-label for="title" [isRequired]="true">
              {{ i18n.dgUserOutcomeEditForm_DescribeAccomplishment }}
            </dgx-reactive-forms-label>
            <input
              type="text"
              id="title"
              formControlName="title"
              [placeholder]="i18n.dgUserOutcomeEditForm_ExpandedClientBase"
              (blur)="loadInferredSkills()"
              data-dgat="accomplishment-global-add-275"
            />
            <dgx-validate-field
              class="block"
              *ngIf="
                accomplishmentGlobalAddForm.get('title').touched &&
                accomplishmentGlobalAddForm.get('title').invalid
              "
              [message]="i18n.MediaFormCtrl_TitleRequired"
            ></dgx-validate-field>
          </div>

          <!-- noExpiration       -->
          <div class="reactive-forms__control">
            <label for="noExpiration" class="reactive-forms__label-checkbox">
              <input
                id="noExpiration"
                df-checkbox
                [checked]="vm.noExpiration"
                type="checkbox"
                name="noExpiration"
                formControlName="noExpiration"
                data-dgat="accomplishment-global-add-3c2"
              />
              <span class="guts-m-l-half">{{
                i18n.dgUserOutcomeEditForm_AccomplishmentDate
              }}</span></label
            >
          </div>

          <!-- Date Range -->
          <div class="reactive-forms__control">
            <dgx-date-range
              [formModel]="{
                startDate: vm.dateRangeForm.startDate,
                endDate: vm.dateRangeForm.endDate
              }"
              [isTouched]="markSubFormsAsTouched"
              [showEndDate]="
                !accomplishmentGlobalAddForm.get('noExpiration').value
              "
              [startDateRequired]="true"
              [endDateRequired]="true"
            ></dgx-date-range>
          </div>

          <!-- Skills -->
          <div class="reactive-forms__control">
            <dgx-tags-edit
              [hideHint]="true"
              [customTagToolTip]="i18n.dgOrgInternalContent_SkillsTooltipText"
              [customTitle]="i18n.Core_Skills"
              [topTags]="vm.inferredSkills$ | async"
              [hideTopTags]="!(vm.inferredSkills$ | async).length"
              [hideTooltip]="false"
              [tooltipIcon]="'info'"
              [placeholder]="i18n.dgOrgInternalContent_SkillsPlaceholderText"
              [allowExistingOnly]="false"
              [tags]="accomplishmentGlobalAddForm.get('skills').value || []"
              [showFullWidthLabel]="true"
              [useNewTagsDesign]="true"
              (tagsChange)="onFormControlUpdate('skills', $event)"
            ></dgx-tags-edit>
            <dgx-validate-field
              class="block"
              *ngIf="
                accomplishmentGlobalAddForm.get('skills').touched &&
                accomplishmentGlobalAddForm.get('skills').invalid
              "
              [message]="i18n.dgOrgInternalContent_SkillsMaxError"
            ></dgx-validate-field>
          </div>
        </div>
      </ng-container>

      <!-- Modal footer -->
      <ng-container class="modal-footer">
        <dgx-global-add-results
          [class.full-width]="vm.shouldShowResults$ | async"
          [buttonText]="submitButtonText"
          [isEditing]="false"
          [isCompleting]="true"
          [isNewbUser]="vm.isNewbUser$ | async"
          [submissionStatus]="vm.submissionStatus$ | async"
          [classifier]="'learning'"
          [showCancelButton]="false"
          [addSpacing]="false"
          (dismissWithNavigation)="onNavigateToCollection($event)"
        >
        </dgx-global-add-results>
      </ng-container>
    </dgx-modal>
  </form>
</ng-container>
